/** 全局layout设置，根据 url.meta 或 url.path */
export default defineNuxtRouteMiddleware((to) => {
  const device = useDevice()
  
  useHead({
    htmlAttrs: {
      id: device.isH5 ? "h5" : "pc",
    },
  })
});